export const adFormInputs = {
  name: '',
  code: '',
  description: '',
};
